// 区块地址特殊类型
export enum BlockChainTypeEnums {
  coinbase = 'explorer_252', //挖矿
}

export const WhitelistTypeEnums = {
  0: 'explorer_253', // 质押转移
  1: 'explorer_254', // gov 地址管理员
  2: 'explorer_255', // 转移区
}

export const ValidatorNodeFormat = {
  GLOBAL: 'Node-1',
  CHN: 'Node-2',
  USA: 'Node-3',
  IND: 'Node-4',
}

export const SequencerStateStatusEnums = {
  OPERATING_STATUS_UNBONDED: 'UnBonded',
  OPERATING_STATUS_UNBONDING: 'UnBonding',
  OPERATING_STATUS_BONDED: 'Bonded',
}
